if (!customElements.get("compare-products")) {
  class CompareProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = this.querySelector(".compare-products__slider");
      this.prevBtn = this.querySelector(".swiper-button-prev");
      this.nextBtn = this.querySelector(".swiper-button-next");

      this.swiper = new Swiper(this.slider, {
        spaceBetween: 14,
        slidesPerView: 'auto',
        grabCursor: true,
        autoHeight: false,
        
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },

        breakpoints: {
          767: {
            spaceBetween: 14,
          },
          1200: {
            spaceBetween: 37,
          },
        },
      });
    }
  }

  customElements.define("compare-products", CompareProducts);
}